import { CombinedGraphQLErrors } from "@apollo/client/errors";
import { alert } from "@components/common/Alert";
import { captureException } from "@sentry/react";
import mixpanel from "mixpanel-browser";

import { HANDLED_EMAIL_FLOW_CODES } from "./emailFlowErrors";

class OperationContext {
  constructor() {
    this.properties = {};
  }

  addProperties(properties) {
    Object.assign(this.properties, properties);
  }
}

export const defaultErrorHandler = (error) => {
  if (!CombinedGraphQLErrors.is(error)) {
    captureException(error);
    alert("error", error.message || "An error occurred");
    return;
  }

  error.errors?.forEach((err) => {
    if (HANDLED_EMAIL_FLOW_CODES.includes(err.extensions?.code)) {
      return;
    }
    alert("error", err.message);
  });
};

export async function trackOperation(
  label,
  operation,
  onError = defaultErrorHandler,
) {
  const startTime = performance.now();
  const ctx = new OperationContext();

  let error = null;
  try {
    await operation(ctx);
  } catch (err) {
    error = err;
  }

  const endTime = performance.now();

  mixpanel.track("Async Operation Complete", {
    label,
    durationMs: endTime - startTime,
    error: error
      ? `${error.constructor.name}: ${error.message}`
      : null,
    errorClass: error?.constructor?.name || null,
    ...ctx.properties,
  });

  if (error) {
    onError(error);
  }
}
